import { CustomFormattedMessage } from '../../../../i18n/i18n';
import { FormattedAddress } from '../../../../components/FormattedAddress';
import {
  FuelingDetails,
  Location as SimplePayLocation,
  ChargingDetails,
} from '../../../../codegen/transactions';
import { SidebarRow } from '../../../../components/sidebar/SidebarRow';

type StationDetailsTableProps = {
  location?: SimplePayLocation;
  fuelingDetails?: FuelingDetails;
  chargingDetails?: ChargingDetails;
};

export const StationDetailsTable = ({
  location,
  fuelingDetails,
  chargingDetails,
}: StationDetailsTableProps) => {
  if (!location) {
    return <></>;
  }

  return (
    <>
      <h6 className="padding-left-10 margin-top-20">
        <CustomFormattedMessage id="common.transaction.stationDetails" />
      </h6>
      <table
        className="table table-condensed"
        data-testid={'transactions-sidebar-station-details'}
      >
        <colgroup>
          <col className="width-150" />
          <col />
        </colgroup>
        <tbody>
          <SidebarRow label="common.contact.name">{location.name}</SidebarRow>
          {location.brand && (
            <SidebarRow label="common.transaction.stationDetails.brand">
              {location.brand}
            </SidebarRow>
          )}
          {fuelingDetails && (
            <SidebarRow label="common.transaction.stationDetails.pumpNo">
              {fuelingDetails.pumpNumber}
            </SidebarRow>
          )}
          <SidebarRow label="common.contact.address">
            <FormattedAddress {...location.address} />
          </SidebarRow>
          {chargingDetails && (
            <>
              <SidebarRow
                label="common.transaction.stationDetails.plugNo"
                show={!!chargingDetails.plugEvseId}
              >
                {chargingDetails.plugEvseId}
              </SidebarRow>
              <SidebarRow
                label="common.transaction.stationDetails.plugType"
                show={!!chargingDetails.plugType}
              >
                {chargingDetails.plugType}
              </SidebarRow>
              <SidebarRow
                label="common.transaction.stationDetails.duration"
                show={!!chargingDetails.duration}
              >
                {chargingDetails.duration}
              </SidebarRow>
            </>
          )}
        </tbody>
      </table>
    </>
  );
};
